/**
 * @fileoverview HeaderTitle - Displays the current page title in the header.
 *
 * @description Maps page identifiers to user-friendly titles for display in the header.
 * Supports all main pages including budget tracking, categories, templates, invites, and reports.
 *
 * @module components/Header/HeaderTitle
 */

import styles from './HeaderTitle.module.css';

const getPageTitle = (currentPage, selectedBudget) => {
    switch (currentPage) {
        case 'budget-tracker':
            return `Budget Tracker - ${selectedBudget?.budgetName || 'Loading...'}`;
        case 'budget-allocation':
            return 'Current Budget Allocation';
        case 'budget-template':
            return 'Budget Template';
        case 'categories':
            return 'Categories';
        case 'create-budget':
            return 'Create New Budget';
        case 'invites':
            return 'Invites';
        case 'report-transaction-type':
            return 'Transaction Type Search';
        case 'report-category':
            return 'Category Search';
        case 'report-month-comparison':
            return 'Month-to-Month Comparison';
        default:
            return 'Budget Tracker';
    }
};

function HeaderTitle({ currentPage, selectedBudget }) {
    return (
        <h2 className={styles.title}>
            {getPageTitle(currentPage, selectedBudget)}
        </h2>
    );
}

export default HeaderTitle;
